import styled from 'styled-components';

export const StyledPopover = styled.div`
  z-index: 100;
  position: absolute;
  top: 40px;
  ${(props) => `${props.align === 'right' ? 'right: 0px' : 'left: 0px'};`}
`;
